import React from 'react';
import PropTypes from 'prop-types';

import { Map } from 'immutable';
import { FormattedMessage } from 'react-intl';

class PassPageNumber extends React.Component {
  constructor(props) {
    super(props);

    this.renderPassPageNumber = this.renderPassPageNumber.bind(this);
  }

  renderPassPageNumber() {
    const { pageIndex } = this.props;
    return (
      <div className="pass-page-number">
        <FormattedMessage
          id="parking-pass.pass"
          defaultMessage="PASS"
        />
        <span className="pass-page-number-box text-color-slate text-weight-book">
          <FormattedMessage
            id="parking-pass.page-status"
            defaultMessage="{currentPage} of {totalPages}"
            values={{
              currentPage: pageIndex.get('currentPage'),
              totalPages: pageIndex.get('totalPages'),
            }}
          />
        </span>
      </div>
    );
  }

  render() {
    const { pageIndex } = this.props;

    return (pageIndex.get('totalPages') === 1 ? null : this.renderPassPageNumber());
  }
}

PassPageNumber.propTypes = {
  pageIndex: PropTypes.instanceOf(Map).isRequired,
};

export default PassPageNumber;
